function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeading2 = function SvgHeading2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    className: "heading-2_svg__icon heading-2_svg__flat-color",
    "data-name": "Flat Color",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-5a1 1 0 0 1-1-1 5.93 5.93 0 0 1 3-5.14l1.26-.72a1.51 1.51 0 0 0 .74-1.31v-.33a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-2 0v-.5a3.5 3.5 0 0 1 7 0v.33a3.51 3.51 0 0 1-1.76 3l-1.24.76A4 4 0 0 0 17.13 18H21a1 1 0 0 1 0 2m-9 0h-2a1 1 0 0 1 0-2v-5H5v5a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2V6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2v5h5V6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2v12a1 1 0 0 1 0 2",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgHeading2;